export default function StickyActions({
  onCancel,
  onSubmit,
  isSubmitting,
  primaryLabel = 'Guardar',
  primaryBusyLabel = 'Guardando...',
  secondaryLabel = 'Cancelar',
  disablePrimary = false,
  secondaryActions = [],
}) {
  return (
    <div
      className="sticky bottom-0 left-0 z-[12] mt-3 w-full pt-2"
      aria-label="Acciones del formulario"
    >
      <div
        className="mx-auto flex w-full flex-col items-stretch gap-2 rounded-[20px] border border-[rgba(var(--border),0.9)] bg-[rgba(var(--panel),0.97)] px-3 py-2.5 shadow-[0_-8px_24px_rgba(var(--shadow),0.08)] backdrop-blur md:flex-row md:items-center md:justify-between"
      >
        <p className="text-[11px] font-medium uppercase tracking-[0.08em] text-[rgb(var(--muted))]">
          Accion principal siempre visible
        </p>

        <div className="flex w-full flex-wrap justify-end gap-2 md:w-auto md:flex-nowrap">
          <button
            type="button"
            className="inline-flex min-h-9 items-center justify-center gap-2 rounded-xl border border-[rgba(var(--border),0.5)] bg-[rgba(var(--panel),0.8)] px-4 py-2 text-[13px] font-semibold text-[rgb(var(--fg))] shadow-xs outline-none transition hover:bg-[rgba(var(--panel),0.92)] focus-visible:ring-2 focus-visible:ring-[rgb(var(--ring))] disabled:cursor-not-allowed disabled:opacity-70"
            onClick={onCancel}
            disabled={isSubmitting}
          >
            {secondaryLabel}
          </button>

          {secondaryActions.map(action => (
            <button
              key={action.label}
              type="button"
              className="inline-flex min-h-9 items-center justify-center gap-2 rounded-xl border border-[rgba(var(--brand),0.28)] bg-[rgba(var(--brand),0.08)] px-4 py-2 text-[13px] font-semibold text-[rgb(var(--fg))] shadow-xs outline-none transition hover:bg-[rgba(var(--brand),0.14)] focus-visible:ring-2 focus-visible:ring-[rgb(var(--ring))] disabled:cursor-not-allowed disabled:opacity-70"
              onClick={action.onClick}
              disabled={isSubmitting || action.disabled}
              aria-label={action.ariaLabel || action.label}
            >
              {action.label}
            </button>
          ))}

          <button
            type="button"
            className="inline-flex min-h-9 items-center justify-center gap-2 rounded-xl bg-[rgb(var(--brand))] px-4 py-2 text-[13px] font-semibold text-white shadow-xs outline-none transition hover:bg-[rgb(var(--brand-700))] focus-visible:ring-2 focus-visible:ring-[rgb(var(--ring))] disabled:cursor-not-allowed disabled:opacity-70"
            onClick={onSubmit}
            disabled={isSubmitting || disablePrimary}
          >
            {isSubmitting ? <span className="spinner" aria-hidden="true" /> : null}
            {isSubmitting ? primaryBusyLabel : primaryLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
